import { useQuery } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig from '@/api/useGetFetchConfig';

export const useGetDuplicateScanStatus = (matterId: string) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<{ scanning: boolean }, Error>(
    [QueryEntity.DuplicateScanStatus, { matterId }],
    async () => {
      const response = await fetch(
        `${APIBaseChronos}/api/matter/${matterId}/files/duplicate-scan-status`,
        fetchConfigGET,
      );
      if (!response.ok) {
        throw new Error('Failed to fetch duplicate scan status');
      }
      return await response.json();
    },
    { enabled: !!matterId, refetchOnWindowFocus: false },
  );
};
